var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.62,5.049C24.62,5.049,19.186,4,15,4S5.38,5.049,5.38,5.049L2,9c0,0,0,3.136,0,6c0,0,0,0.001,0,0.001c0,2.864,0,6,0,6l3.38,3.951c0,0,5.434,1.049,9.62,1.049s9.62-1.049,9.62-1.049L28,21.001c0,0,0-3.136,0-6c0,0,0-0.001,0-0.001c0-2.864,0-6,0-6L24.62,5.049z M12,19.601v-9.202L20,15L12,19.601z","key":0}),React.createElement("path",{"d":"M24 5A4 4 0 1 0 24 13 4 4 0 1 0 24 5zM24 17A4 4 0 1 0 24 25 4 4 0 1 0 24 17zM2 9c0 2.209 1.791 4 4 4s3-1.791 3-4S8.209 5 6 5 2 6.791 2 9zM6 17A4 4 0 1 0 6 25 4 4 0 1 0 6 17z","key":1})]);
}

Youtube.defaultProps = {"fill":"#000000","viewBox":"0 0 30 30","width":"30px","height":"30px"};

module.exports = Youtube;

Youtube.default = Youtube;
